import { grid2Categories } from '@/mocks/categories';

export default function CategoryGrid2() {
  return (
    <section className="relative py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-xs md:text-sm text-foreground-500 font-label tracking-widest uppercase mb-3">
            More Essentials
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Explore<br />
            <span className="italic font-medium text-accent-500">Every Category</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {grid2Categories.map((cat, idx) => {
            const bgColors = [
              'bg-[#dce4e8]',
              'bg-[#eadcd4]',
              'bg-[#e8e4d8]',
              'bg-[#d4e0d4]',
            ];
            return (
              <a
                key={cat.seq}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group block rounded-2xl overflow-hidden bg-white hover:scale-[1.02] transition-transform duration-300 cursor-pointer"
              >
                <div className={`h-[280px] md:h-[340px] ${bgColors[idx]} flex items-center justify-center p-8`}>
                  <img
                    src={cat.imageUrl}
                    alt={`CSSBuy ${cat.name} Spreadsheet`}
                    title={`CSSBuy ${cat.name} Spreadsheet`}
                    className="w-full h-full object-cover object-center rounded-xl"
                    loading="lazy"
                  />
                </div>
                <div className="px-5 py-4">
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 border-b border-foreground-200 pb-1 inline-block">
                    Browse collection &rarr;
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}